<p-toast styleClass="custom-toast" ></p-toast><router-outlet></router-outlet>